import React, { useState } from 'react';
import { Calendar, MapPin, Users, Clock, Search, Filter, Award, Video, Coffee, Plus, Building2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { Input } from '../components/ui/Input';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/Tabs';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
export function EventsPage() {
  const navigate = useNavigate();
  const {
    user
  } = useAuth();
  const [activeTab, setActiveTab] = useState('all');
  const [organizerFilter, setOrganizerFilter] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  // Check if user can create events
  const canCreateEvent = user?.role === 'ketua_chapter' || user?.role === 'ketua_student_chapter' || user?.role === 'anggota_organisasi' || user?.role === 'anggota_badan_usaha' || user?.role === 'mitra_asosiasi' || user?.role === 'koordinator_acara';
  const events = [{
    id: 1,
    category: 'training',
    title: 'Workshop React & Next.js Lanjutan',
    description: 'Workshop intensif 2 hari tentang React dan Next.js untuk level advanced',
    date: '15-16 Januari 2025',
    time: '09:00 - 17:00 WIB',
    location: 'Jakarta Tech Hub',
    type: 'offline',
    price: 'Rp 500.000',
    memberPrice: 'Rp 250.000',
    seats: 30,
    registered: 18,
    instructor: 'John Doe',
    certificate: true,
    status: 'open',
    organizer: 'Jakarta Tech Community',
    organizerType: 'chapter'
  }, {
    id: 2,
    category: 'seminar',
    title: 'Tren AI & Machine Learning 2025',
    description: 'Seminar tentang tren terkini AI dan Machine Learning di industri',
    date: '20 Januari 2025',
    time: '14:00 - 17:00 WIB',
    location: 'Online (Zoom)',
    type: 'online',
    price: 'Gratis',
    memberPrice: 'Gratis',
    seats: 100,
    registered: 67,
    instructor: 'Dr. Sarah Williams',
    certificate: true,
    status: 'open',
    organizer: 'Komite Pusat ATIOS',
    organizerType: 'komite_pusat'
  }, {
    id: 3,
    category: 'meeting',
    title: 'Rapat Koordinasi Chapter Jakarta',
    description: 'Rapat koordinasi bulanan chapter Jakarta untuk membahas program kerja',
    date: '22 Januari 2025',
    time: '19:00 - 21:00 WIB',
    location: 'Kantor Jakarta',
    type: 'offline',
    price: 'Gratis',
    memberPrice: 'Gratis',
    seats: 50,
    registered: 23,
    instructor: 'Budi Santoso',
    certificate: false,
    status: 'open',
    organizer: 'Jakarta Tech Community',
    organizerType: 'chapter'
  }, {
    id: 4,
    category: 'training',
    title: 'Bootcamp Fundamental DevOps',
    description: 'Bootcamp intensif 5 hari DevOps dari dasar hingga advanced',
    date: '25-29 Januari 2025',
    time: '09:00 - 17:00 WIB',
    location: 'Bandung Training Center',
    type: 'offline',
    price: 'Rp 2.500.000',
    memberPrice: 'Rp 1.500.000',
    seats: 25,
    registered: 25,
    instructor: 'Ahmad Wijaya',
    certificate: true,
    status: 'full',
    organizer: 'PT Tech Indonesia',
    organizerType: 'organisasi'
  }, {
    id: 5,
    category: 'seminar',
    title: 'Best Practice Keamanan Siber',
    description: 'Webinar tentang best practice keamanan siber untuk developer',
    date: '28 Januari 2025',
    time: '15:00 - 17:00 WIB',
    location: 'Online (Google Meet)',
    type: 'online',
    price: 'Gratis',
    memberPrice: 'Gratis',
    seats: 200,
    registered: 145,
    instructor: 'Rina Situmorang',
    certificate: true,
    status: 'open',
    organizer: 'CV Digital Solutions',
    organizerType: 'badan_usaha'
  }, {
    id: 6,
    category: 'meeting',
    title: 'Rapat Komite Pusat - Q1 2025',
    description: 'Rapat komite pusat untuk evaluasi Q4 2024 dan perencanaan Q1 2025',
    date: '30 Januari 2025',
    time: '10:00 - 15:00 WIB',
    location: 'Kantor Pusat ATIOS Jakarta',
    type: 'offline',
    price: 'Khusus Undangan',
    memberPrice: 'Khusus Undangan',
    seats: 30,
    registered: 28,
    instructor: 'Komite Pusat',
    certificate: false,
    status: 'invitation-only',
    organizer: 'Komite Pusat ATIOS',
    organizerType: 'komite_pusat'
  }, {
    id: 7,
    category: 'seminar',
    title: 'Webinar Kolaborasi Industri',
    description: 'Webinar tentang kolaborasi industri dan akademisi',
    date: '5 Februari 2025',
    time: '14:00 - 16:00 WIB',
    location: 'Online (Zoom)',
    type: 'online',
    price: 'Gratis',
    memberPrice: 'Gratis',
    seats: 150,
    registered: 89,
    instructor: 'Tech Partner Corp',
    certificate: true,
    status: 'open',
    organizer: 'Tech Partner Corp',
    organizerType: 'mitra'
  }];
  const filteredEvents = events.filter(event => {
    const matchesTab = activeTab === 'all' || event.category === activeTab;
    const matchesOrganizer = organizerFilter === 'all' || event.organizerType === organizerFilter;
    const matchesSearch = event.title.toLowerCase().includes(searchQuery.toLowerCase()) || event.description.toLowerCase().includes(searchQuery.toLowerCase()) || event.organizer.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesTab && matchesOrganizer && matchesSearch;
  });
  const getCategoryIcon = (category: string) => {
    switch (category) {
      case 'training':
        return Award;
      case 'seminar':
        return Video;
      case 'meeting':
        return Coffee;
      default:
        return Calendar;
    }
  };
  const getCategoryColor = (category: string) => {
    switch (category) {
      case 'training':
        return 'text-atios-primary';
      case 'seminar':
        return 'text-success';
      case 'meeting':
        return 'text-warning';
      default:
        return 'text-neutral-400';
    }
  };
  const getOrganizerBadge = (type: string) => {
    switch (type) {
      case 'chapter':
        return <Badge variant="primary" className="text-xs" data-id="element-2952">
            Chapter
          </Badge>;
      case 'organisasi':
        return <Badge variant="success" className="text-xs" data-id="element-2953">
            Organisasi
          </Badge>;
      case 'badan_usaha':
        return <Badge variant="warning" className="text-xs" data-id="element-2954">
            Badan Usaha
          </Badge>;
      case 'mitra':
        return <Badge variant="default" className="text-xs" data-id="element-2955">
            Mitra
          </Badge>;
      default:
        return <Badge className="text-xs bg-atios-primary text-white" data-id="element-2956">
            Komite Pusat
          </Badge>;
    }
  };
  const stats = [{
    label: 'Total Acara',
    value: events.length.toString(),
    icon: Calendar
  }, {
    label: 'Acara Diikuti',
    value: '3',
    icon: Users
  }, {
    label: 'Sertifikat Diperoleh',
    value: '2',
    icon: Award
  }];
  return <div className="min-h-screen bg-white" data-id="element-2957">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8" data-id="element-2958">
        {/* Header */}
        <div className="flex justify-between items-start" data-id="element-2959">
          <div data-id="element-2960">
            <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-2961">
              Acara & Pelatihan
            </h1>
            <p className="text-neutral-600" data-id="element-2962">
              Ikuti berbagai acara, pelatihan, seminar, dan rapat di ATIOS
            </p>
          </div>
          {canCreateEvent && <Button onClick={() => navigate('/events/create')} data-id="element-2963">
              <Plus className="w-4 h-4 mr-2" data-id="element-2964" />
              Buat Event
            </Button>}
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-2965">
          {stats.map((stat, i) => <Card key={i} data-id="element-2966">
              <CardContent className="p-6" data-id="element-2967">
                <div className="flex items-center gap-4" data-id="element-2968">
                  <div className="h-12 w-12 rounded-lg bg-atios-light flex items-center justify-center" data-id="element-2969">
                    <stat.icon className="h-6 w-6 text-atios-primary" data-id="element-2970" />
                  </div>
                  <div data-id="element-2971">
                    <p className="text-2xl font-semibold text-neutral-900" data-id="element-2972">
                      {stat.value}
                    </p>
                    <p className="text-sm text-neutral-600" data-id="element-2973">{stat.label}</p>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>

        {/* Search & Organizer Filter */}
        <div className="flex flex-col sm:flex-row gap-4" data-id="element-2974">
          <div className="flex-1 relative" data-id="element-2975">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-neutral-400" data-id="element-2976" />
            <Input placeholder="Cari acara, pelatihan, atau seminar..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="pl-10" data-id="element-2977" />
          </div>
          <div className="flex gap-2" data-id="element-2978">
            <select value={organizerFilter} onChange={e => setOrganizerFilter(e.target.value)} className="px-4 py-2 rounded-lg border border-neutral-300 bg-white text-sm text-neutral-900 focus:outline-none focus:ring-2 focus:ring-atios-primary" data-id="element-2979">
              <option value="all" data-id="element-2980">Semua Penyelenggara</option>
              <option value="komite_pusat" data-id="element-2981">Komite Pusat</option>
              <option value="chapter" data-id="element-2982">Chapter</option>
              <option value="organisasi" data-id="element-2983">Organisasi</option>
              <option value="badan_usaha" data-id="element-2984">Badan Usaha</option>
              <option value="mitra" data-id="element-2985">Mitra</option>
            </select>
          </div>
        </div>

        {/* Tabs */}
        <Tabs defaultValue="all" className="w-full" data-id="element-2986">
          <TabsList className="bg-neutral-100 border border-neutral-200" data-id="element-2987">
            <TabsTrigger value="all" onClick={() => setActiveTab('all')} data-id="element-2988">
              Semua Acara
            </TabsTrigger>
            <TabsTrigger value="training" onClick={() => setActiveTab('training')} data-id="element-2989">
              Pelatihan
            </TabsTrigger>
            <TabsTrigger value="seminar" onClick={() => setActiveTab('seminar')} data-id="element-2990">
              Seminar
            </TabsTrigger>
            <TabsTrigger value="meeting" onClick={() => setActiveTab('meeting')} data-id="element-2991">
              Rapat
            </TabsTrigger>
          </TabsList>

          <TabsContent value={activeTab} className="mt-6" data-id="element-2992">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-2993">
              {filteredEvents.map(event => {
              const CategoryIcon = getCategoryIcon(event.category);
              const categoryColor = getCategoryColor(event.category);
              return <Card key={event.id} className="cursor-pointer hover:shadow-md transition-all" onClick={() => {
                if (event.category === 'meeting' && event.id === 6) {
                  navigate(`/meetings/${event.id}`);
                } else {
                  navigate(`/events/${event.id}`);
                }
              }} data-id="element-2994">
                    <CardHeader data-id="element-2995">
                      <div className="flex items-start justify-between mb-3" data-id="element-2996">
                        <div className={`h-10 w-10 rounded-lg bg-neutral-100 flex items-center justify-center ${categoryColor}`} data-id="element-2997">
                          <CategoryIcon className="h-5 w-5" data-id="element-2998" />
                        </div>
                        <div className="flex flex-col gap-1 items-end" data-id="element-2999">
                          <Badge variant={event.status === 'open' ? 'success' : event.status === 'full' ? 'error' : 'default'} data-id="element-3000">
                            {event.status === 'open' ? 'BUKA' : event.status === 'full' ? 'PENUH' : 'UNDANGAN'}
                          </Badge>
                          {event.certificate && <Badge variant="default" className="text-xs" data-id="element-3001">
                              <Award className="w-3 h-3 mr-1" data-id="element-3002" />
                              Sertifikat
                            </Badge>}
                        </div>
                      </div>
                      <CardTitle className="text-base text-neutral-900" data-id="element-3003">
                        {event.title}
                      </CardTitle>
                      <div className="flex items-center gap-2 mt-2" data-id="element-3004">
                        <Building2 className="w-3 h-3 text-neutral-400" data-id="element-3005" />
                        <span className="text-xs text-neutral-600" data-id="element-3006">
                          {event.organizer}
                        </span>
                        {getOrganizerBadge(event.organizerType)}
                      </div>
                    </CardHeader>
                    <CardContent className="space-y-4" data-id="element-3007">
                      <p className="text-sm text-neutral-600 line-clamp-2" data-id="element-3008">
                        {event.description}
                      </p>

                      <div className="space-y-2 text-xs" data-id="element-3009">
                        <div className="flex items-center gap-2 text-neutral-600" data-id="element-3010">
                          <Calendar className="w-3.5 h-3.5 text-atios-primary" data-id="element-3011" />
                          <span data-id="element-3012">{event.date}</span>
                        </div>
                        <div className="flex items-center gap-2 text-neutral-600" data-id="element-3013">
                          <Clock className="w-3.5 h-3.5 text-atios-primary" data-id="element-3014" />
                          <span data-id="element-3015">{event.time}</span>
                        </div>
                        <div className="flex items-center gap-2 text-neutral-600" data-id="element-3016">
                          <MapPin className="w-3.5 h-3.5 text-atios-primary" data-id="element-3017" />
                          <span data-id="element-3018">{event.location}</span>
                          <Badge variant="outline" className="text-xs ml-auto" data-id="element-3019">
                            {event.type === 'online' ? 'Online' : 'Offline'}
                          </Badge>
                        </div>
                        <div className="flex items-center gap-2 text-neutral-600" data-id="element-3020">
                          <Users className="w-3.5 h-3.5 text-atios-primary" data-id="element-3021" />
                          <span data-id="element-3022">
                            {event.registered}/{event.seats} peserta
                          </span>
                        </div>
                      </div>

                      <div className="pt-4 border-t border-neutral-200" data-id="element-3023">
                        <div className="flex items-center justify-between mb-3" data-id="element-3024">
                          <div data-id="element-3025">
                            <p className="text-xs text-neutral-500" data-id="element-3026">
                              Harga Reguler
                            </p>
                            <p className="text-sm text-neutral-400 line-through" data-id="element-3027">
                              {event.price}
                            </p>
                          </div>
                          <div className="text-right" data-id="element-3028">
                            <p className="text-xs text-neutral-500" data-id="element-3029">
                              Harga Anggota
                            </p>
                            <p className="text-base font-semibold text-atios-primary" data-id="element-3030">
                              {event.memberPrice}
                            </p>
                          </div>
                        </div>
                        <Button className="w-full" size="sm" disabled={event.status === 'full' || event.status === 'invitation-only'} onClick={e => {
                      e.stopPropagation();
                      if (event.status === 'open') {
                        navigate(`/events/${event.id}/register`);
                      }
                    }} data-id="element-3031">
                          {event.status === 'open' ? 'Daftar Sekarang' : event.status === 'full' ? 'Penuh' : 'Khusus Undangan'}
                        </Button>
                      </div>
                    </CardContent>
                  </Card>;
            })}
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </div>;
}